module.exports = __webpack_public_path__ + "static/media/profile.62f255e2.svg";